import UriTemplate from 'uri-templates';
import {context} from "../constants/context";
import {halClient} from "../hal";
import {BBModel} from "../bb_model";

const adminBooking = {

    getBooking(prms) {
        if (prms.company && !prms.company_id) {
            prms.company_id = prms.company.id;
        }

        let url = '';
        if (prms.url) {
            ({url} = prms);
        }
        const href = `${url}/api/${context.apiVersion}/admin/{company_id}/bookings/{id}{?embed}`;
        const uri = new UriTemplate(href).fillFromObject(prms || {});
        return halClient.$get(uri, {no_cache: true}).then((item) => {
            const booking = new BBModel.Admin.Booking(item);
            return Promise.resolve(booking);
        })
            .catch((err) => {
                return Promise.reject(err);
            });
    },

    cancelBooking(prms, booking) {
        return new Promise((resolve, reject) => {
            const href = `/api/${context.apiVersion}/admin/{company_id}/bookings/{id}?notify={notify}`;
            if (prms.id == null) {
                prms.id = booking.id;
            }

            let {notify} = prms;
            if (notify == null) {
                notify = true;
            }

            const uri = new UriTemplate(href).fillFromObject(prms || {});
            halClient.$del(uri, {notify}).then((item) => {
                    booking = new BBModel.Admin.Booking(item);
                    return resolve(booking);
                }
                , (err) => {
                    return reject(err);
                }
            );
        });
    },

    updateBooking(prms, booking) {
        return new Promise((resolve, reject) => {
            const href = `/api/${context.apiVersion}/admin/{company_id}/bookings/{id}`;
            if (prms.id == null) {
                prms.id = booking.id;
            }

            const uri = new UriTemplate(href).fillFromObject(prms || {});
            halClient.$put(uri, {}, prms).then((item) => {
                    booking = new BBModel.Admin.Booking(item);
                    return resolve(booking);
                }
                , (err) => {
                    return reject(err);
                }
            );
        });
    },

    blockTimeForPerson(prms, person) {
        return new Promise((resolve, reject) => {
            const href = `/api/${context.apiVersion}/admin/{company_id}/people/{person_id}/block`;
            if (prms.person_id == null) {
                prms.person_id = person.id;
            }
            prms.booking = true;
            const uri = new UriTemplate(href).fillFromObject(prms || {});
            halClient.$put(uri, {}, prms).then((item) => {
                    const booking = new BBModel.Admin.Booking(item);
                    return resolve(booking);
                }
                , (err) => {
                    return reject(err);
                }
            );
        });
    },

    addStatusToBooking(prms, booking, status) {
        return new Promise((resolve, reject) => {
            const href = `/api/${context.apiVersion}/admin/{company_id}/bookings/{booking_id}/multi_status`;
            if (prms.booking_id == null) {
                prms.booking_id = booking.id;
            }
            const uri = new UriTemplate(href).fillFromObject(prms || {});
            halClient.$put(uri, {}, {status}).then((item) => {
                    booking = new BBModel.Admin.Booking(item);
                    return resolve(booking);
                }
                , (err) => {
                    return reject(err);
                }
            );
        });
    },

    addPrivateNoteToBooking(prms, booking, note) {
        let noteParam;
        const url = prms.url || '';
        const href = `${url}/api/${context.apiVersion}/admin/{company_id}/bookings/{booking_id}/private_notes`;

        if (prms.booking_id == null) {
            prms.booking_id = booking.id;
        }

        if (note.note != null) {
            noteParam = note.note;
        }
        if (noteParam == null) {
            noteParam = note;
        }

        const uri = new UriTemplate(href).fillFromObject(prms || {});

        return halClient.$put(uri, {}, {note: noteParam})
            .then((item) => {
                booking = new BBModel.Admin.Booking(item);

                return Promise.resolve(booking);
            })
            .catch((err) => {
                console.error('Error adding private note.');
                return Promise.reject(err);
            });
    },

    updatePrivateNoteForBooking(prms, booking, note) {
        const url = prms.url || '';
        const href = `${url}/api/${context.apiVersion}/admin/{company_id}/bookings/{booking_id}/private_notes/{id}`;

        if (prms.booking_id == null) {
            prms.booking_id = booking.id;
        }
        if (prms.id == null) {
            prms.id = note.id;
        }

        const uri = new UriTemplate(href).fillFromObject(prms || {});

        return halClient.$put(uri, {}, {note: note.note})
            .then((item) => {
                booking = new BBModel.Admin.Booking(item);
                return Promise.resolve(booking);
            })
            .catch((err) => {
                console.error('Error updating private note.');
                return Promise.reject(err);
            });
    },

    deletePrivateNoteFromBooking(prms, booking, note) {
        return new Promise((resolve, reject) => {
            const href = `/api/${context.apiVersion}/admin/{company_id}/bookings/{booking_id}/private_notes/{id}`;
            if (prms.booking_id == null) {
                prms.booking_id = booking.id;
            }
            if (prms.id == null) {
                prms.id = note.id;
            }

            const uri = new UriTemplate(href).fillFromObject(prms || {});
            halClient.$del(uri, {}).then((item) => {
                    booking = new BBModel.Admin.Booking(item);
                    return resolve(booking);
                }
                , (err) => {
                    return reject(err);
                }
            );
        });
    }
};

export {
    adminBooking
}
